import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetails } from '../components/ProductDetails';
import { PricingSection } from '../components/PricingSection';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-224">
      <Hero data-id="element-225" />
      <ProblemSection data-id="element-226" />
      <SolutionSection data-id="element-227" />
      <ProductDetails data-id="element-228" />
      <PricingSection data-id="element-229" />
      <FAQ data-id="element-230" />
      <Footer data-id="element-231" />
    </main>;
}